<template>
  <div
    class="premium-buy-page"
    data-test="page-premium">
    <div class="m-t-2">
      <add-payment-info
        heading="Billing Information"
        @success="successAction"
      />
    </div>
  </div>
</template>

<script>
import UpdatePaymentInfo from '../../components/subscription/UpdatePaymentInfo';
import PageMixin from '../../shared/pageMixin';

export default {
  name: 'AdyenBuyPremiumPage',
  components: {
    'add-payment-info': UpdatePaymentInfo,
  },
  mixins: [PageMixin],
  data() {
    return {
      pageName: 'Premium Subscription',
    };
  },
  computed: {
    user() {
      const { user } = this.$store.getters;

      return user;
    },
  },
  mounted() {
    window.eventBus.$emit('onboarding-step-change', -1);
  },
  methods: {
    successAction() {
      if (this.user && this.user.registration_state === 'onboarding_topics') {
        this.$router.push('/user-categories');
      } else {
        this.$router.push({ path: '/listen', query: { newSubscription: true } });
      }
    },
  },
};
</script>

<style lang='scss'>
.premium-buy-page{
  max-width: 468px;
  width: 100%;
  margin: auto;
  padding: 52px 0 92px 0;
}
@media (max-width: 567px) {
  .premium-buy-page{
    width: auto;
    padding: 21px 32px;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/onboarding/AdyenBuyPremium.vue